export const infoArea = document.createElement('div');
infoArea.id = 'info-area';
infoArea.className = 'hide';
const infoTitle = document.createElement('div');
infoTitle.innerText = 'This is the Information Area';
infoArea.appendChild(infoTitle);
